import React from "react";
import { useState, useEffect, useRef } from "react";

const SidebarItem = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(true);
  const contentRef = useRef(null);
  const [contentHeight, setContentHeight] = useState(0);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const calculateHeight = () => {
    if (contentRef.current) {
      // Force a reflow to get accurate height
      const height = contentRef.current.scrollHeight;
      setContentHeight(height);
    }
  };

  useEffect(() => {
    calculateHeight();
  }, [children]); // Update height when children change

  // Recalculate height when accordion opens
  useEffect(() => {
    if (isOpen) {
      // Use setTimeout to ensure DOM is updated
      setTimeout(() => {
        calculateHeight();
      }, 0);
    }
  }, [isOpen]);

  // Use ResizeObserver to handle dynamic content changes
  useEffect(() => {
    if (!contentRef.current) return;

    const resizeObserver = new ResizeObserver(() => {
      if (isOpen) {
        calculateHeight();
      }
    });

    resizeObserver.observe(contentRef.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [isOpen]);

  return (
    <div
      className={`order-list__item cart-accordion${
        isOpen ? " cart-accordion--active" : ""
      }`}
    >
      <div className="cart-accordion__header" onClick={toggleAccordion}>
        <h3 className="cart-accordion__title">{title}</h3>
      </div>
      <div
        className="cart-accordion__body"
        style={{
          maxHeight: isOpen ? `${contentHeight}px` : "0",
          overflow: "hidden",
          transition: "max-height 0.3s ease-out",
        }}
        ref={contentRef}
      >
        {children}
      </div>
    </div>
  );
};

export default SidebarItem;

